/**
 * El segmento de la URL-capacidad de la entrega, en UN solo sitio.
 *
 * `/tu-video/<publicToken>` no es una ruta cualquiera: quien tiene el enlace ve
 * y descarga el vídeo de un menor SIN sesión. Por eso el literal lo comparten
 * tres módulos que no se conocen entre sí —la URL que se publica
 * (`delivery-url.ts`), el `Disallow` de `app/robots.ts` y la lista de rutas
 * sensibles de `analytics-url-policy.ts`—, y hasta ahora cada uno lo escribía a
 * mano. Renombrar el directorio de la página compilaba, pasaba `next build` y
 * pasaba la suite (los tests afirmaban el literal, no la relación), y dejaba la
 * URL-capacidad entrando en GTM, en Vercel Analytics y en el session replay de
 * PostHog. Derivándolo, el rename se propaga o no compila.
 *
 * **Módulo propio, y sin una sola dependencia, a propósito.** No vale meterlo
 * en `delivery-url.ts`: aquél importa `@/lib/brands` para resolver el origen, y
 * `analytics-url-policy.ts` corre en el NAVEGADOR (lo usa `AnalyticsBoundary`,
 * que es `'use client'`). Una constante no puede arrastrar el catálogo de
 * marcas al bundle sólo para decir cómo se llama un directorio.
 */
export const VIDEO_DELIVERY_SEGMENT = 'tu-video'

/**
 * El mismo segmento, ya escapado para interpolarlo dentro de un `RegExp`.
 *
 * Hoy `tu-video` no tiene un solo metacarácter y las dos expresiones que lo
 * interpolan —las rutas sensibles de `analytics-url-policy.ts` y el filtro de
 * rama del gate `routes/video-delivery-dynamic`— funcionan igual con o sin
 * esto. Pero el punto ENTERO de esta constante es que el literal se pueda
 * mover, y un `.` en el segmento nuevo convertiría ambas en comodines: la
 * política de analítica dejaría pasar rutas que no son la entrega y el gate
 * miraría ficheros de más. Un ablandamiento silencioso de dos defensas es
 * exactamente lo que no puede depender de que nadie elija un punto.
 */
export const VIDEO_DELIVERY_SEGMENT_PATTERN = VIDEO_DELIVERY_SEGMENT.replace(
  /[.*+?^${}()|[\]\\]/g,
  '\\$&',
)
